import { LoggedOutOrNoJiraProductTourOverview } from "@/templates/jira-product-tour-overview/src";

export const JiraLandingPage = () => {
    const template = <LoggedOutOrNoJiraProductTourOverview />;

    return template;
};
